// @ts-nocheck
import * as $ from 'jquery';

$('[data-inputlength]').on('input',
    function (e) {
        const input = $(e.currentTarget);
        const maxLength = parseInt(input.attr('data-inputlength'));
        if (input.val().length > maxLength) {
            input.val(input.val().substr(0, maxLength));
        }
    }
);
